module.exports = __webpack_public_path__ + "static/img/iEP-3.13d8840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/iEP-3.jpg
// module id = kgUE
// module chunks = 1